import { defineStore } from 'pinia'
import { shallowRef, Component, ref } from 'vue'

export const useInterfaceStore = defineStore(
    'interface',
    () => {
        const layout = shallowRef<Component | string>()

        type Preferences = {
            timeZone?: string
            fahrenheit: boolean
            locale?: string
            downloadReport?: {
                pageSize?: 'a4' | 'us-letter'
                fileType?: 'pdf' | 'xls'
                timeZone?: string
                locale?: string
                temperatureUnit?: 'celsius' | 'fahrenheit'
                includeDataTable?: 'minimal' | 'full'
            }
        }
        const preferences = ref<Preferences>({
            timeZone: undefined,
            fahrenheit: false,
            locale: undefined,
            downloadReport: {
                pageSize: 'a4',
                fileType: 'pdf',
                timeZone: 'utc',
                locale: 'en-US',
                temperatureUnit: 'celsius',
                includeDataTable: 'minimal'
            }
        })

        return { layout, preferences }
    },
    {
        persist: true
    }
)
